<div class="pageheader">
    <div class="page-title">
        <h1>Test Runs</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
            <button class="btn btn-link" (click)="runTestCases()">Run Test Cases <ep-svg-icon icon="plus"></ep-svg-icon></button>
        </div>
    </div>
</div>

<dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='testRuns' [bizSetColumnChooser]="true" [bizSetAllowColumnReordering]="false" [bizSetSearchPanel]="true" [bizSetPager]="false"
    [bizEditRowOnDoubleClick]="false" (onRowRemoving)="onRowRemoving($event)" (onRowDblClick)="viewTestRunDocumentsDoubleClickEvent($event)">

    <dxo-editing mode="row" [allowUpdating]="false" [allowAdding]="false" [allowDeleting]="true"></dxo-editing>

    <dxi-column dataField="RunDateTime" caption="Created Date" dataType="date" sortOrder="desc" [format]="dateTimeService.getDevExpressDateTimeFunction" [allowFiltering]="true" [allowGrouping]="true"
        [visible]="true"></dxi-column>
    <dxi-column dataField="TestCaseName" caption="Test Case Name" dataType="string" [allowFiltering]="true" [allowGrouping]="true" [visible]="true"></dxi-column>
    <dxi-column dataField="Comment" caption="Comment" dataType="string" [allowFiltering]="true" [allowGrouping]="true" [visible]="true"></dxi-column>
    <dxi-column dataField="Status" caption="Test Run Status" dataType="string" cellTemplate="statusTemplate" [allowFiltering]="true" [allowGrouping]="true" [visible]="true"></dxi-column>
    <dxi-column dataField="TotalTestCaseInterchangesCount" caption="Total Interchanges" dataType="number" [allowFiltering]="true" [allowGrouping]="true" [visible]="true"></dxi-column>
    <dxi-column dataField="TotalDocumentsCount" caption="Total Documents" dataType="number" [allowFiltering]="true" [allowGrouping]="true" [visible]="true"></dxi-column>
    <dxi-column dataField="TotalDocumentsCompletedCount" caption="Completed Documents" dataType="number" [allowFiltering]="true" [allowGrouping]="true" [visible]="true"></dxi-column>
    <dxi-column dataField="TotalFailedCompareCount" caption="Failed Compare" dataType="number" [allowFiltering]="true" [allowGrouping]="true" [visible]="true"></dxi-column>

    <dxi-column type="buttons">
        <dxi-button text="Results" hint="View document compare results" [onClick]="viewTestRunDocumentsRowEvent"></dxi-button>
        <dxi-button text="Test Case" hint="Go to Test Case" [onClick]="viewTestCaseRowEvent"></dxi-button>
        <dxi-button name="delete"></dxi-button>
    </dxi-column>

    <div *dxTemplate="let cell of 'statusTemplate'">
        @if (cell.data.Status === 'Undetermined') {
        <span></span>
        }
        @if (cell.data.Status === 'Active') {
        <span style="color: orangered;">Active</span>
        }
        @if (cell.data.Status === 'DocumentProcessingCompleted') {
        <span style="color: rgb(45, 99, 160);">Document Processing Completed</span>
        }
        @if (cell.data.Status === 'TestCompleted') {
        <span class="text-success">Success</span>
        }
        @if (cell.data.Status === 'TestAccepted') {
        <span class="text-info">Accepted</span>
        }
        @if (cell.data.Status === 'TestFailed') {
        <span class="text-danger">Failed</span>
        }
    </div>
</dx-data-grid>
